import React from 'react';

class Education extends React.Component {
  render() {
    return (
      <section id="education-section" className="education-section section">
        <h2 className="section-title">Education</h2>
        <div className="row">
          <div className="item col-xs-12 col-sm-4 col-sm-offset-4">
            <div className="item-inner">
              <h3 className="degree">Masters of Computer Science</h3>
              <div className="education-body">
                Minsk State Radioengineering College
                <br />
                Minsk, Belarus
              </div>
              <div className="time">1999 - 2005</div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Education.propTypes = {
  route: React.PropTypes.object,
};

export default Education;



// WEBPACK FOOTER //
// ../components/Blocks/Education.jsx